"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineClassifierHashEntity = void 0;
const App_1 = require("@juvare/platform-app/App");
const shared_1 = require("../shared");
function defineClassifierHashEntity() {
    return (0, App_1.defineEntity)({
        version: 1,
        columns: shared_1.classifierHashColumns,
        onMigrate: (params) => params.oldData,
        onTransformColumns: (_context, params) => {
            return {
                classifierName: params.data.classifierName,
                hash: params.data.hash,
            };
        },
        onAuthGet: () => {
            throw new Error('Unauthorized');
        },
        onAuthList: () => {
            throw new Error('Unauthorized');
        },
        onAuthPost: () => {
            throw new Error('Unauthorized');
        },
        onAuthAttachment: () => {
            throw new App_1.AuthError('Unauthorized');
        },
    });
}
exports.defineClassifierHashEntity = defineClassifierHashEntity;
